<!-- Skip to main content link for keyboard navigation -->
<a class="skip-link" href="#main-content">Skip to main content</a>

<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="bg-white print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation.default" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center h-20 p-6 pb-0">
            <a [routerLink]="'/home'" class="inline-flex items-center">
                <img class="w-30" src="assets/images/logo/logo-text.svg" alt="Logo image">
            </a>
        </div>
        <!-- Quick Create Widget -->
        <div class="flex items-center justify-center w-full px-6 pb-4">
            <quick-create></quick-create>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <!-- <languages></languages> -->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!-- <search [appearance]="'bar'"></search> -->
            <shortcuts></shortcuts>
            <!-- <messages></messages> -->
            <notifications></notifications>
            <!-- <button class="lg:hidden" mat-icon-button (click)="quickChat.toggle()">
                <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
            </button> -->
            <user></user>
        </div>
    </div>

    <!-- Critical Alerts Banner -->
    <critical-alerts-banner></critical-alerts-banner>

    <!-- Content -->
    <div id="main-content" class="flex flex-col flex-auto" role="main" aria-label="Main content">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div
        class="relative flex flex-col flex-0 w-full px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <!-- Copyright line -->
        <div class="flex items-center w-full h-8 mt-4">
            <span class="text-xs font-medium text-secondary">HoneyTokens &copy; {{currentYear}} | v{{appVersion}}</span>
        </div>
        <!-- Government logos line -->
        <div class="flex items-center justify-center w-full pb-4 flex-wrap gap-4 sm:gap-6 md:gap-8">
            <img class="h-12 sm:h-14 md:h-16 w-auto flex-shrink-0" src="assets/images/footer/SVG/footer-UE.svg"
                alt="Unión Europea">
            <img class="h-12 sm:h-14 md:h-16 w-auto flex-shrink-0"
                src="assets/images/footer/SVG/footer-Gobierno.svg" alt="Gobierno de España">
            <img class="h-12 sm:h-14 md:h-16 w-auto flex-shrink-0"
                src="assets/images/footer/SVG/footer-plan-recuperacion.svg" alt="Plan de Recuperación">
            <img class="h-12 sm:h-14 md:h-16 w-auto flex-shrink-0" src="assets/images/footer/SVG/footer-incibe.svg"
                alt="INCIBE">
        </div>
    </div>

</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->